import { EXAM_PAPER_ITEM_TYPE } from 'Components/Quiz/constant';

export const mapSectionList = (sections) => {
  const sectionList = sections.map((section) => ({
    value: section.sourceId,
    label: section.title,
  }));

  return sectionList;
};

export const mapProblemListBySection = (sections) => {
  const problemListBySection = sections.reduce((acc, section) => {
    acc[section.sourceId] = section.solutions.map((solution) => ({
      value: solution.id,
      label: solution.problemNo.toString(),
    }));
    return acc;
  }, {});

  return problemListBySection;
};

export function mapSolutionAnswer(data) {
  if (!data) return null;

  if (
    data.type === EXAM_PAPER_ITEM_TYPE.MULTIPLE_SELECT ||
    data.type === EXAM_PAPER_ITEM_TYPE.MULTIPLE_SELECT_WITH_CORRECT_ANSWERS
  ) {
    return data.answer.choiceIds.map((choiceId) => {
      const index = data.question.choices.findIndex((choice) => choice.choiceId === choiceId);
      const answer = { ...(data.question.choices[index] || null), answerIndex: index + 1 };
      return answer;
    });
  }

  if (
    data.type === EXAM_PAPER_ITEM_TYPE.MULTIPLE_CHOICE ||
    data.type === EXAM_PAPER_ITEM_TYPE.MULTIPLE_CHOICE_DIFFERENT_SCORE
  ) {
    const index = data.question.choices.findIndex(
      (choice) => choice.choiceId === data.answer.choiceId
    );
    const answer = { ...(data.question.choices[index] || null), answerIndex: index + 1 };
    return answer;
  }

  if (data.type === EXAM_PAPER_ITEM_TYPE.FILL_NUMBER) {
    return data.answer.value;
  }
}
